export default "__VITE_ASSET__CiF$25fl__"